<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I3ZT5/tc-custom/9781439664087.jpg?1705026193429" alt="This image is the cover for the book Kirk's Civil War Raids Along the Blue Ridge, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kirk's Civil War Raids Along the Blue Ridge, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In the Southern Appalachian Mountains, no character was more loved or despised than George W. Kirk.</b></p><br/><p>This inured Union officer led a group of deserters on numerous raids between Tennessee and North Carolina in 1863, terrorizing Confederate soldiers and civilians alike. At Camp Vance in Morganton, Kirk's mounted raiders showcased guerrilla warfare penetrating deep within Confederate territory. As Home Guards struggled to keep Western North Carolina communities safe, Kirk's men brought fear and violence throughout the region for their ability to strike and create havoc without warning. Civil War historian Michael C. Hardy examines the infamous history of George W. Kirk and the Civil War along the Blue Ridge.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael C. Hardy
      </h2>
      
      <p class="authorDescription body article">Michael Hardy has authored twenty-two books, and his articles have appeared in Civil War Times, America's Civil War, North and South, Gettysburg Magazine, the Tar Heel Junior Historians and Confederate Veteran. Since 2014 he has reviewed books for Blue and Gray magazine. Michael is also the past chair of the Yancey Historical Association and the Avery County Historical Society and Museum. Since 2011, he has been a volunteer-in-parks on the Blue Ridge Parkway, providing historic interpretation about the Civil War in the mountains. In 2015, the Hardy family was named as volunteers of the year for the Pisgah District, Blue Ridge Parkway. Hardy was awarded the 2010 historian of the year award by the North Carolina Society of Historians. Michael lives in the Blue Ridge Mountains with his wife Elizabeth, and children Nathaniel and Isabella. You can learn more through his blog Looking for North Carolina's Civil War or his web page, www.michaelchardy.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?053a9d18